const stripTikTokDecorations = (value = "") => {
  const cleaned = String(value || "").trim();
  if (!cleaned) return "";
  return cleaned
    .replace(/^https?:\/\//i, "")
    .replace(/^www\./i, "")
    .replace(/[?#].*$/, "")
    .replace(/\/+$/, "");
};

export const canonicalizeTikTokProfileUrl = (value = "") => {
  const normalized = stripTikTokDecorations(value);
  const match = normalized.match(/^tiktok\.com\/@([a-zA-Z0-9._]{1,24})$/i);
  if (!match) return "";
  return `https://www.tiktok.com/@${match[1]}`;
};

export const canonicalizeTikTokVideoUrl = (value = "") => {
  const normalized = stripTikTokDecorations(value);
  const full = normalized.match(/^tiktok\.com\/@([a-zA-Z0-9._]+)\/video\/([0-9]+)$/i);
  if (full) return `https://www.tiktok.com/@${full[1]}/video/${full[2]}`;
  const short = normalized.match(/^v[mt]\.tiktok\.com\/([a-zA-Z0-9]+)$/i);
  if (short) return `https://vm.tiktok.com/${short[1]}`;
  return "";
};
